
import  {
    faCaretUp,
} from "@awesome.me/kit-db56931b65/icons/sharp/solid";

const sharpSolid = {
    faCaretUp,
};

export {
    sharpSolid,
};
